import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

let loadPromise: Promise<void> | null = null;
let isConfigured = false;

export const googleApiKey = "AIzaSyAN_tXAEt07r_ujKX0iyjdn7zX9T9H5GWA";


/* 1. In my firefox the is error in browser console about failing to load stats.js. I think this may happen because of my local setup. Chrome doesn't have it.
2. As of February 21st, 2024, google.maps.Marker is deprecated.
We can't do anything about this since markers are added by google fleet.
*/
export const loadGoogleMaps = async (): Promise<void> => {
	if (loadPromise) {
		return loadPromise;
	}

	loadPromise = (async () => {
		try {
			// Check if Google Maps is already loaded
			if (window.google && window.google.maps) {
				return;
			}

			// Configure the loader once
			if (!isConfigured) {
				setOptions({
					key: googleApiKey,
					v: "weekly"
				});
				isConfigured = true;
			}

			// Import the required libraries
			// Note: journeySharing has an internal dependency on visualization library
			await Promise.all([
				importLibrary("core"),
				importLibrary("maps"),
				importLibrary("geometry"),
				importLibrary("drawing"),
				importLibrary("places"),
				importLibrary("visualization"),
				importLibrary("journeySharing")
			]);
		} catch (error) {
			console.error('Failed to load Google Maps:', error);
			throw error;
		}
	})();

	return loadPromise;
};
